import styled from 'styled-components';

import { ReactComponent as Chevron } from 'assets/images/chevron-small.svg';
import { ReactComponent as Passenger } from 'assets/images/passenger.svg';

export const Card: any = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;

  box-shadow: 0px 6px 10px rgba(128, 98, 96, 0.16);
  border-radius: 12px;
  padding: 16px;
  margin: 16px 0;
`;

export const Title = styled.h4`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.71;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.flightDetails.card.title};
`;

export const Header = styled.div`
  display: flex;
  cursor: pointer;
  font-size: 10px;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.flightSector.color};
`;

export const Arrow = styled(Chevron)`
  width: 12px;
  height: 12px;
  padding: 0 2px;
  box-sizing: content-box;
  color: #626e75;
  transform: rotate(90deg);

  &.active {
    transform: rotate(270deg);
  }
`;

export const PassengerIcon = styled(Passenger)`
  width: 20px;
  height: 20px;
  color: #332927;
  margin-right: 5px;
`;

export const Container = styled.div`
  & > div {
    border-bottom: solid 1px ${({ theme }) => theme.flightDetails.cancellationPolicies.cardContent};

    &:last-child {
      border: 0;
    }
  }
`;

export const Content: any = styled.div`
  padding: 16px 0;

  & p {
    margin: 8px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Row = styled.div`
  padding: 8px 0;

  &:first-child {
    padding-top: 16px;
  }
`;

export const Label = styled.span`
  color: #706967;
  font-size: 12px;
  line-height: 130%;
`;

export const Value = styled.span`
  color: #332927;
  font-size: 14px;
  line-height: 140%;
`;
